import { useTranslation } from 'react-i18next'

import Text from '../../../../../Text'

import * as styles from './ListingProfileWidgetPublishingCount.module.css'

function ListingProfileWidgetPublishingCount({
  doneCount,
  isSecondary,
  total,
}) {
  const { t } = useTranslation()

  return (
    <Text
      className={styles.ListingProfileWidgetPublishingCount}
      isSecondary={isSecondary}
    >
      {t('RentalPortal.ListingProfileReadinessCountKey', {
        done: doneCount,
        total,
      })}
    </Text>
  )
}

export default ListingProfileWidgetPublishingCount
